import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { Center, Loader } from '@mantine/core';
import { useSession } from './SessionContext';

/**
 * Wraps protected routes. If unauthenticated, redirects to /login preserving
 * the intended URL via `state.from`.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { state } = useSession();
  const location = useLocation();

  if (state.status === 'loading') {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }
  if (state.status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
